const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    openCardText: () =>
        __('Se søgekriterier'),
    hitcount: (n, formatted = n) =>
        __nx('{n} jobopslag', '{n} jobopslag', n, { n: formatted }),
    active: () =>
        __('Aktiv'),
    inactive: () =>
        __('Inaktiv'),
    noSearchParams: () =>
        __('Ingen søgeparametre.'),
    keywords: () =>
        __('Søgeord'),
    categories: () =>
        __('Kategorier'),
    oldCategories: () =>
        __('Gamle kategorier'),
    oldCategoryTooltip: () =>
        __('Gem din Jobagent for at fjerne denne notifikation'),
    areas: () =>
        __('Områder'),
    companies: () =>
        __('Virksomheder'),
    activate: () =>
        __('Aktivér'),
    deactivate: () =>
        __('Deaktiver'),
    edit: () =>
        __('Ret'),
    doSearch: () =>
        __('Udfør søgning'),
    history: () =>
        __('Historik'),
    delete: () =>
        __('Slet'),
    daily: () =>
        __('Hver dag'),
    weekly: () =>
        __('Hver lørdag'),
    radiusAddress: (radius, address) =>
        __x('Maks {radius} km fra {address}', { radius, address }),
    switchDaily: () =>
        __('Skift til daglig'),
    switchWeekly: () =>
        __('Skift til ugentlig'),
};
